import { DataBean } from "../DataBean";

export class GoodsState extends DataBean {



    public async deleteGoodsState(idGoodsState: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteGoodsState_Number", [idGoodsState]);
    }

    public async getGoodsStateCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getGoodsStateCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}